// Central registry of data-testids for the Supreme Web Security IP Tracker app.
export const APP = {
  // Public
  landingHero: 'landing-hero',
  landingGetStarted: 'landing-get-started-btn',
  landingStartScan: 'landing-start-scan-btn',
  landingViewReport: 'landing-view-report-btn',
  landingRequestPI: 'landing-request-pi-btn',
  landingContactSecurity: 'landing-contact-team-btn',
  packageScan: 'package-scan-card',
  packagePlus: 'package-plus-card',
  packageWebPI: 'package-webpi-card',
  packageScanCta: 'package-scan-cta',
  packagePlusCta: 'package-plus-cta',
  packageWebPiCta: 'package-webpi-cta',
  contactForm: 'contact-form',
  contactSubmit: 'contact-submit-btn',

  // Auth
  loginPage: 'login-page',
  loginGoogleBtn: 'login-google-btn',
  authCallback: 'auth-callback',
  logoutBtn: 'logout-btn',

  // Layout/Nav
  sidebar: 'app-sidebar',
  navOverview: 'nav-overview',
  navScan: 'nav-scan',
  navIpTracker: 'nav-ip-tracker',
  navAlerts: 'nav-alerts',
  navReports: 'nav-reports',
  navSettings: 'nav-settings',
  navSupport: 'nav-support',
  navAdmin: 'nav-admin',

  // Scan page
  scanConsent: 'scan-consent-checkbox',
  scanStartBtn: 'scan-start-btn',
  scanNetworkInput: 'scan-network-input',
  scanLocationInput: 'scan-location-input',
  scanResults: 'scan-results',
  scanRiskBadge: 'scan-risk-badge',

  // IP Tracker
  ipTrackerTable: 'ip-tracker-table',
  ipFilterStatus: 'ip-filter-status',
  deviceRow: 'device-row',
  deviceRenameBtn: 'device-rename-btn',
  deviceTrustBtn: 'device-trust-btn',
  deviceBlockBtn: 'device-block-btn',

  // Alerts
  alertItem: 'alert-item',
  alertResolveBtn: 'alert-resolve-btn',

  // Reports
  reportsList: 'reports-list',
  reportPdfBtn: 'report-pdf-btn',
  reportCsvBtn: 'report-csv-btn',
  reportEmailBtn: 'report-email-btn',

  // Settings
  ruleNewBtn: 'rule-new-btn',
  ruleNameInput: 'rule-name-input',
  ruleCreateBtn: 'rule-create-btn',
  scheduleCreateBtn: 'schedule-create-btn',

  // Customer overview
  customerDashboard: 'customer-dashboard',
  cardActiveDevices: 'card-active-devices',
  cardAlerts: 'card-alerts',
  cardRisk: 'card-risk',
  cardLastScan: 'card-last-scan',

  // Support
  supportSubject: 'support-subject',
  supportMessage: 'support-message',
  supportSubmit: 'support-submit',

  // Admin
  adminDashboard: 'admin-dashboard',
  adminTabCustomers: 'admin-tab-customers',
  adminTabAlerts: 'admin-tab-alerts',
  adminTabTickets: 'admin-tab-tickets',
  adminTabInvoices: 'admin-tab-invoices',
  adminTabLogs: 'admin-tab-logs',
  adminTabPackageReqs: 'admin-tab-pkg-reqs',
  adminCustomerRow: 'admin-customer-row',
  adminPackageSelect: 'admin-package-select',
  adminInvoiceCreate: 'admin-invoice-create-btn',
  adminNoteInput: 'admin-note-input',
  adminNoteSubmit: 'admin-note-submit',
};
